// const baseURL = "http://localhost:5002"; 

// const baseURL = "http://69.62.81.122:4000";

// const baseURL = "https://southsutra.com:5000";

const baseURL = "https://shreeshashwatraj.com:9000";



export default baseURL;